import { mtFetch, type FetchResult } from "./mtFetch";

/** Одна запись лога вызова /v1/external/translate. */
export interface ApiLogCall {
  readonly log_id: string;
  readonly created_at: string | null;
  readonly token_id: string | null;
  readonly token_name: string | null;
  readonly draft_id: string | null;
  readonly source_lang: string | null;
  readonly target_lang: string | null;
  readonly backend: string | null;
  readonly backend_model: string | null;
  readonly text_sha256: string | null;
  readonly text_length: number | null;
  readonly translated_length: number | null;
  readonly latency_ms: number | null;
  readonly status: string | null;
  readonly error: string | null;
}

export interface ApiLogTokenFacet {
  readonly token_id: string;
  readonly token_name: string | null;
}

export interface ApiLogList {
  readonly schema_version: string;
  readonly total: number;
  readonly count: number;
  readonly limit: number;
  readonly offset: number;
  readonly sort: string;
  readonly order: string;
  readonly backends: readonly string[];
  readonly tokens: readonly ApiLogTokenFacet[];
  readonly calls: readonly ApiLogCall[];
}

export interface ApiLogParams {
  readonly limit?: number;
  readonly offset?: number;
  readonly status?: string;
  readonly token_id?: string;
  readonly backend?: string;
  readonly sort?: "created_at" | "latency";
  readonly order?: "asc" | "desc";
}

export function listApiLog(
  params: ApiLogParams = {},
): Promise<FetchResult<ApiLogList>> {
  const qs = new URLSearchParams();
  if (params.limit != null) qs.set("limit", String(params.limit));
  if (params.offset != null) qs.set("offset", String(params.offset));
  if (params.status) qs.set("status", params.status);
  if (params.token_id) qs.set("token_id", params.token_id);
  if (params.backend) qs.set("backend", params.backend);
  if (params.sort) qs.set("sort", params.sort);
  if (params.order) qs.set("order", params.order);
  const q = qs.toString();
  return mtFetch<ApiLogList>(`/admin/api-log-list${q ? `?${q}` : ""}`);
}
